import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcReviewH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m41.058 54.519-8.656 8.656c-1.262 1.262-3.412.365-3.412-1.414v-6.695c0-.52-.398-.95-.913-1.015C16.755 52.615 8 42.948 8 31.235c0-12.702 10.298-23 23-23h10c12.703 0 23 10.298 23 23 0 12.451-9.894 22.592-22.249 22.988-.26.008-.51.112-.693.296m.629-2.295c-.629 0-1.484.32-2.043.88l-8.654 8.654v-6.692c0-1.577-1.198-2.813-2.661-2.999C17.993 50.757 10 41.927 10 31.235c0-11.598 9.402-21 21-21h10c11.598 0 21 9.402 21 21 0 11.368-9.034 20.627-20.313 20.99M24.011 21.235a1 1 0 1 0 0 2h21a1 1 0 0 0 0-2zm-1 10a1 1 0 0 1 1-1h27a1 1 0 0 1 0 2h-27a1 1 0 0 1-1-1m1 8.002a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2z",
    clipRule: "evenodd"
  }));
}
var IcReviewH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcReviewH72));

export { IcReviewH72 as I };
